'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useWallets } from '@morfi/backend-sdk-v2/client';
import { OtherPortfolio } from '@/components/portfolio/other-portfolio';
import { OwnPortfolio } from '@/components/portfolio/own-portfolio';
import { PortfolioLoadingSkeleton } from '@/components/portfolio/portfolio-loading-skeleton';
interface PortfolioDispatcherProps {
  /** The user id or pubkey from the URL. */
  targetId: string;
}

/**
 * Auth-derived router for `/portfolio/[user_id]`. Dispatches to
 * {@link OwnPortfolio} when the authenticated user matches the target,
 * else {@link OtherPortfolio}.
 */
export function PortfolioDispatcher(t0) {
  const $ = _c(9);
  const {
    targetId
  } = t0;
  const {
    user,
    isLoading,
    isAuthenticated
  } = useAuth();
  const {
    wallets
  } = useWallets();
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PortfolioLoadingSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== isAuthenticated || $[2] !== targetId || $[3] !== user || $[4] !== wallets) {
    t1 = isAuthenticated && user !== null && (user.id === targetId || wallets.some(w => w.address === targetId));
    $[1] = isAuthenticated;
    $[2] = targetId;
    $[3] = user;
    $[4] = wallets;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const isViewerSelf = t1;
  let t2;
  if ($[6] !== isViewerSelf || $[7] !== targetId) {
    t2 = isViewerSelf ? <OwnPortfolio perfRoute="profile" perfInstanceKey={targetId} /> : <OtherPortfolio targetId={targetId} />;
    $[6] = isViewerSelf;
    $[7] = targetId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}